.heading {
  font-size: 15px;
  font-weight: 600;
  line-height: 1.35;
  text-align: center;

  > span {
    display: inline-block;
  }
}
